<template>
  <div id="app" class="min-width">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue